export const BLOG_T = {
  pt: {
    nav: { back: "← Voltar para o site" },
    list: {
      overline: "Blog · Solte seu francês",
      title: "Histórias, dicas e atalhos para destravar seu francês.",
      subtitle:
        "Artigos escritos pelo Professor Lionel — gramática, expressões, cultura francesa, preparação para provas e os erros mais comuns dos brasileiros.",
      read: "Ler artigo",
      minRead: "min de leitura",
    },
    post: {
      backToBlog: "← Voltar para o blog",
      readNext: "Continuar lendo",
      ctaBadge: "1ª aula · 100% grátis · 50 min",
      ctaTitle: "Pronto para soltar seu francês de verdade?",
      ctaBody:
        "Marque sua aula experimental com o Prof. Lionel — sem cartão, sem compromisso. Em 50 minutos você sai com 3 erros corrigidos, sua pronúncia ajustada e um plano de estudo desenhado pra você.",
      ctaBook: "Quero minha aula grátis",
      ctaTest: "Antes, fazer o teste de nível",
      ctaMicro: "Online via Zoom · Resposta em até 24h · Aulas em PT, EN ou FR",
      ctaFloating: "Aula grátis",
      ctaFloatingClose: "Fechar",
      skeletonNote: "Artigo em construção · em breve, conteúdo completo.",
    },
  },
  en: {
    nav: { back: "← Back to the site" },
    list: {
      overline: "Blog · Unlock your French",
      title: "Stories, tips and shortcuts to unlock your French.",
      subtitle:
        "Articles written by Professor Lionel — grammar, idioms, French culture, exam prep and the most common Brazilian mistakes.",
      read: "Read article",
      minRead: "min read",
    },
    post: {
      backToBlog: "← Back to the blog",
      readNext: "Keep reading",
      ctaBadge: "1st class · 100% free · 50 min",
      ctaTitle: "Ready to actually speak French?",
      ctaBody:
        "Book your trial class with Prof. Lionel — no card, no strings. In 50 minutes you'll leave with 3 mistakes corrected, your pronunciation tuned and a study plan built around you.",
      ctaBook: "Claim my free class",
      ctaTest: "First, take the level test",
      ctaMicro: "Online on Zoom · Reply within 24h · Classes in PT, EN or FR",
      ctaFloating: "Free class",
      ctaFloatingClose: "Close",
      skeletonNote: "Article in progress · full content coming soon.",
    },
  },
  fr: {
    nav: { back: "← Retour au site" },
    list: {
      overline: "Blog · Libérez votre français",
      title: "Histoires, conseils et raccourcis pour libérer votre français.",
      subtitle:
        "Des articles écrits par le Professeur Lionel — grammaire, expressions, culture française, préparation aux examens et erreurs les plus fréquentes des Brésiliens.",
      read: "Lire l'article",
      minRead: "min de lecture",
    },
    post: {
      backToBlog: "← Retour au blog",
      readNext: "Continuer la lecture",
      ctaBadge: "1er cours · 100 % offert · 50 min",
      ctaTitle: "Prêt·e à parler vraiment français ?",
      ctaBody:
        "Réservez votre cours d'essai avec le Prof. Lionel — sans carte, sans engagement. En 50 minutes vous repartirez avec 3 erreurs corrigées, votre prononciation ajustée et un plan d'étude conçu pour vous.",
      ctaBook: "Je réserve mon cours offert",
      ctaTest: "D'abord, passer le test de niveau",
      ctaMicro: "En ligne sur Zoom · Réponse sous 24h · Cours en PT, EN ou FR",
      ctaFloating: "Cours offert",
      ctaFloatingClose: "Fermer",
      skeletonNote: "Article en cours · contenu complet à venir.",
    },
  },
};
